import React, { useEffect, useState } from 'react'
import { ReactComponent as Back } from "../../../../images/redBack.svg";
import { ReactComponent as Edit } from "../../../../images/editIcon.svg";
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { NavItem, NavLink, Nav, Tab} from "react-bootstrap"
import { Col,Row } from "reactstrap";
import TieredPricing from './TieredPricing/TieredPricing';
import ProcessingFees from './ProcessingFees';
import PinDebit from './PinDebit';
import ACHService from './ACHService';
import Gateway from './Gateway';
import EquipmentAndTerminals from './EquipmentAndTerminals';
import GiftCardLoyaltyAndClosedLoop from './GiftCardLoyaltyAndClosedLoop';
import SaveTemplateForm from './TieredPricing/SaveTemplateForm';
import { duration } from 'moment';

interface IPricingTabs{
  message:Function;
  cancelButton:Function;
  disable:boolean;
}

const PricingTabs = (props:IPricingTabs) => {
  const {message, cancelButton,disable} = props
  const [activeTab, setActiveTab] = useState(0);
  const [saveToggle,setSaveToggle] = useState<boolean>(false)
  const [disableField, setDisableField] = useState<boolean>(true)
  
   
  const editHandler = () =>{
    setDisableField(false)
  }

  const tabs = [
    { 
      id: 0,
      name: 'Tiered Pricing',
      element: <TieredPricing disableField={disableField ? disable : disableField}/>
    },
    {
      id: 1,
      name: 'Processing Fees',
      element: <ProcessingFees />
    },
    {
      id: 2,
      name: 'Pin Debit',
      element: <PinDebit />
    },
    {
      id: 3,
      name: 'ACH Service',
      element: <ACHService />
    },
    {
      id: 4,
      name: 'Gate way',
      element: <Gateway />
    },
    {
      id: 5,
      name: 'Equipment & Terminals',
      element: <EquipmentAndTerminals />
    },
    {
      id: 6,
      name: 'Gift Card, Loyalty, Closed Loop',
      element: <GiftCardLoyaltyAndClosedLoop />
    },
  ]

  const tabToggle  = (tab: number) => {
    if (activeTab != tab) {
      setActiveTab(tab);
    }
  };

  const saveFormToggleHandler = () => {
    // message('save')
    setSaveToggle(!saveToggle)
  }

  return (
    <Row className="pricingTabs">
      <div className="topContainer">
        <div className='cancelButtonContainer'>
          <Back className="backTriangle" />
          <button className="cancelButton" onClick={()=>cancelButton()}>Cancel</button>
        </div>
        <p className="header">Sample Template Name</p>
        <button className="saveButton" onClick={()=>saveFormToggleHandler()}>Save</button>
      </div>
      <p className="pricingHeading">Pricing</p>
      <Tab.Container defaultActiveKey="Tiered Pricing">
      <Col className="tabsContainer" sm={3}>
        <Nav className="flex-column">
          {tabs.map((m) =>
            <NavItem>
              <NavLink eventKey={m.name} onClick={() => tabToggle(m.id)}>
                <div className="tabItem">
                <span className="tabName">{m.name}</span>
                {activeTab === m.id && <div className="editContainer">
                  <button className={`editButton`}  onClick={editHandler}>
                  <Edit/>
                    <span>Edit</span>
                    </button>
                </div>}
                </div>
              </NavLink>
            </NavItem>
          )}
        </Nav>
      </Col>
        <Col className="componentContainer" sm={9}>
        {tabs.map((tab) =>
            activeTab === tab.id ? (
              <Tab.Pane key={tab.name} eventKey={tab.name}>
                {tab.element}
              </Tab.Pane>
            ) : null
          )}
        </Col>
      </Tab.Container>
      <SaveTemplateForm
        modalToggle={saveFormToggleHandler}
        toggle={saveToggle}
        className="saveTemplate"
        cancelButton={cancelButton}
        message={message}
      />
    </Row>
  )
}

export default PricingTabs